import { useContext, useEffect, useMemo } from "react";
import { AuthContext } from "../context/AuthContext";
import { useLocationCtx } from "../context/LocationContext";
import { setCountryGateState } from "../utils/countryGateState";

export function useCountryGate() {
  const { user } = useContext(AuthContext) || {};
  const { guestLoaded, explicitUserSelectedCountry, guestCountry } = useLocationCtx();

  const isAuthenticated = !!user?.id;
  const needsCountrySelection = useMemo(
    () => guestLoaded && !isAuthenticated && !explicitUserSelectedCountry && !guestCountry,
    [guestLoaded, isAuthenticated, explicitUserSelectedCountry, guestCountry]
  );

  useEffect(() => {
    setCountryGateState(needsCountrySelection);
  }, [needsCountrySelection]);

  return { needsCountrySelection, isAuthenticated };
}
